import { InternalAxiosRequestConfig } from 'axios';
import { RequestInterceptor } from './Interceptor';

export class RequestTimestampInterceptor implements RequestInterceptor {
  async onFulfilled(config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> {
    config.headers['X-Request-Timestamp'] = Math.floor(Date.now() / 1000).toString();
    return config;
  }
}
